module.exports = __webpack_public_path__ + "static/Student2-b20239b110b8159fc5db5815451dad2c.jpg";